import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";

export default class RulesPanelView extends AbstractView {

    constructor(target, openButtonFromParent, languagePack, gameAssets) {
        super(target);
        this._languagePack = languagePack;
        this._gameAssets = gameAssets;

        this._panel = this._target.contents;
        this._openButtonFromParent = openButtonFromParent;
        this._toggle = this.createButton(this._panel.toggle, this._handleToggle.bind(this));
        this._toggleFromParent = this.createButton(this._openButtonFromParent, this._handleToggle.bind(this));
        this._panel.closeInstructionsTextfield.text = this.getText("rules.closeInstructions");

        //block clicks through panel, quick and dirty
        this._panel.getChildAt(0).addEventListener("click", () => { });

        this._animating = false;
        this._openY = 0;
        this._closeY = target.contents.y;
        this._panel.y = this._closeY;

        this._slots = [];
        for (let i = 0; i < 99; i++) {
            const slot = this._panel["slot" + i];
            if (!slot) {
                break;
            }
            this._slots.push(slot);
            slot.origX = slot.x;
            slot.origY = slot.y;
        }

        this.close(true);
    }

    set enabled(value) {
        this._enabled = value;
        this._toggle.setEnabled(value);
        this._toggleFromParent.setEnabled(value);
    }

    /**
     * 
     * @param {string} id Id of puzzle
     */
    showRulesForPuzzle(id) {
        this._panel.gotoAndStop(id);
        const target = this._panel["level_" + id];
        target.gotoAndStop(0);
        const prefix = "rules." + id + ".";
        target.children.forEach(obj => {2
            const name = obj.name;
            if (name) {
                //find all actor textfields and fill in name
                if (name.indexOf("actorName_") == 0) {
                    const id = name.split("_")[1];
                    obj.textfield.text = this.getText("actors." + id);
                }
                //find all actor textfields and fill in name
                else if (name.indexOf("eat") == 0) {
                    obj.textfield.text = this.getText("rules.eat");
                }
                //find all actor textfields and fill in name
                else if (name.indexOf("text") == 0) {
                    obj.text = this.getText(prefix + name);
                }
            }
        });
    }

    setContent(title, body, actorParams) {
        if (!this._titleOrigHeight) {
            this._titleOrigHeight = this._panel.titleTextfield.getMeasuredHeight();
            this._bodyOrigY = this._panel.bodyTextfield.y;
        }
        this._panel.titleTextfield.text = title;
        this._panel.bodyTextfield.text = body;
        this._panel.bodyTextfield.y = this._bodyOrigY + this._panel.titleTextfield.getMeasuredHeight() - this._titleOrigHeight;
        this.setActors(actorParams);
    }

    setActors(actorParams) {
        this._slots.forEach(slot => { slot.visible = false; });
        //actorParams: id, skin
        const n = actorParams.length;
        for (let i = 0; i < n; i++) {
            const slot = this._slots[i];
            slot.visible = true;
            const { id, skin: skinId } = actorParams[i]
            const skin = new this._gameAssets[skinId]();
            slot.image.removeAllChildren();
            slot.image.addChild(skin);
            slot.nameTextfield.text = this.getText("actors." + id);
        }
        this.positionSlots(n);
    }

    positionSlots(n) {
        this._slots.forEach(slot => {
            slot.setTransform(slot.origX, slot.origY);
        });
        const dx = (this._slots[1].x - this._slots[0].x) / 2;
        switch (n) {
            case 4:
                //n==4: 2x2 centered
                this._slots[0].x += dx;
                this._slots[1].x += dx;
                this._slots[2].setTransform(this._slots[3].x + dx, this._slots[3].y);
                this._slots[3].setTransform(this._slots[4].x + dx, this._slots[4].y);
                break;
            case 5:
                //n==5: bottom row 2 elems, centered
                this._slots[3].x += dx;
                this._slots[4].x += dx;
                break;
        }

    }

    _handleToggle(e) {
        if (this._state != State.OPENED) {
            this.open();
        } else {
            this.close();
        }
    }

    open(instant = false) {
        if (this._state != State.OPENED) {
            this._animateTo(this._openY, State.OPENED, instant);
            this.dispatchEvent(RulesPanelView.OPEN);
        }
    }
    close(instant = false) {
        if (this._state != State.CLOSED) {
            this._animateTo(this._closeY, State.CLOSED, instant);
            this.dispatchEvent(RulesPanelView.CLOSE);
        }
    }
    _animateTo(goalY, stateAtEnd, instant) {
        const onComplete = () => {
            this._state = stateAtEnd;
        }
        if (instant) {
            this._panel.y = goalY;
            onComplete();
        } else {
            const dur = Math.abs(this._panel.y - goalY) * .5;
            createjs.Tween.get(this._panel).to({ y: goalY }, dur, createjs.Ease.quadOut).call(onComplete);
        }
    }


};

const State = { CLOSED: 0, CLOSING: 1, OPENING: 2, OPENED: 3 };

RulesPanelView.CLOSE = "RulesPanelView.CLOSE";
RulesPanelView.OPEN = "RulesPanelView.OPEN";